import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=14b0b8f2&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=14b0b8f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b0b8f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b0b8f2')) {
      api.createRecord('14b0b8f2', component.options)
    } else {
      api.reload('14b0b8f2', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=14b0b8f2&scoped=true&", function () {
      api.rerender('14b0b8f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/maintainCustomer/detail.vue"
export default component.exports